import { MarkdownText } from "@/components/text/LokaliseMarkdownText";
import { Disclosure } from "@headlessui/react";
import clsx from "clsx";
import { JsonLd } from "react-schemaorg";
import { ChevronDown } from "@whoppah/icons/24/ChevronDown";

const Accordion = ({ items, className = undefined, size = "normal" }) => {
  return (
    <div className={clsx("w-full pt-[24px]", className)}>
      {items ? (
        <JsonLd
          item={{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: items.map(item => ({
              "@type": "Question",
              name: item.title,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.body,
              },
            })),
          }}
        />
      ) : null}
      <div className="mx-auto w-full bg-white">
        {items.map(item => {
          return (
            <Disclosure
              key={item.title}
              as="div"
              className="border-b border-[#e6e6e6]"
            >
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between py-4 text-left focus:outline-none focus-visible:ring  focus-visible:ring-opacity-75">
                    <h4
                      className={clsx(
                        "font-poppins text-[14px] font-semibold",
                        size === "normal" ? "md:text-[24px]" : "md:text-[18px]"
                      )}
                    >
                      {item.title}
                    </h4>
                    <ChevronDown
                      className={clsx(
                        "block h-6 w-6 shrink-0",
                        open ? "rotate-180 transform" : ""
                      )}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel
                    unmount={false}
                    className="pb-[24px] font-poppins text-[14px]"
                  >
                    <MarkdownText
                      overrides={{
                        h1: {
                          component: "strong",
                        },
                        h2: {
                          component: "strong",
                        },
                        h3: {
                          component: "strong",
                        },
                        h4: {
                          component: "strong",
                        },
                        h5: {
                          component: "strong",
                        },
                        h6: {
                          component: "strong",
                        },
                      }}
                    >
                      {item.formattedBody ?? item.body}
                    </MarkdownText>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          );
        })}
      </div>
    </div>
  );
};

export default Accordion;
